import styled, { CSSObject } from 'styled-components';
import { Variant, VariantEnum } from './types';

interface DivisorStyledProps {
  variant?: Variant;
  mt?: number;
  sx?: CSSObject;
}

export const DivisorStyled = styled.hr<DivisorStyledProps>(
  ({ theme, sx, variant, mt }) => {
    let styleSheet: CSSObject = {
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: theme.color.wfGrey300,
    };

    if (variant === VariantEnum.horizontal) {
      styleSheet = {
        ...styleSheet,
        width: '100%',
        borderBottomWidth: 'thin',
      };
    }
    if (variant === VariantEnum.vertical) {
      styleSheet = {
        ...styleSheet,
        borderRight: `1px solid ${theme.color.wfGrey300}`,
        marginLeft: theme.space[2],
        marginRight: theme.space[2],
        alignSelf: 'stretch',
        height: 'auto',
      };
    }

    if (mt) {
      styleSheet.marginTop = theme.space[mt];
    }

    return {
      ...styleSheet,
      ...sx,
    };
  },
);
